// extracted by mini-css-extract-plugin
module.exports = {"container":"ExCarouselHeader_container__MkiZH","title-section":"ExCarouselHeader_title-section__t4BVI"};